import { NavItemProps } from "../components/Navbar/NavItem/NavItem";

export const navBarItems: NavItemProps[] = [
    {
        title: "introduction",
        to: "introduction"
    },
    {
        title: "about",
        to: "about-me"
    },
    {
        title: "work experience",
        to: "work-experience"
    },
]
